import { styled, SxProp, useDripsyTheme, View } from 'dripsy';
import React from 'react';
import { Modal } from 'react-native';
import Animated from 'react-native-reanimated';
import { UseModalProps } from './useModalView.hook';

const ModalContainer = styled(Modal)();

interface ModalViewProps {
  useModalProps: UseModalProps;
  sx?: SxProp;
  minWidth?: number;
  overflow?: 'visible' | 'hidden';
  marginTop?: number;
}

export const ModalView: React.FC<ModalViewProps> = ({ sx, useModalProps, minWidth, children, overflow, marginTop }) => {
  const { theme } = useDripsyTheme();
  const { modalVisible, childRef, animatedStyle, dimensions } = useModalProps;

  return (
    <ModalContainer transparent={true} visible={modalVisible} sx={{ backgroundColor: 'transparent', ...sx }}>
      <View
        sx={{
          flex: 1,
          backgroundColor: '#00000090',
          justifyContent: 'center',
          alignItems: 'center'
        }}>
        <Animated.View
          style={[
            {
              minWidth,
              maxWidth: 500,
              backgroundColor: (theme.colors?.$backgroundPrimary as string) || '#FFFFFF',
              overflow: overflow || 'hidden',
              borderRadius: theme.space?.$radius2 as number,
              marginTop
            },
            animatedStyle
          ]}>
          <View
            ref={childRef}
            onLayout={({ nativeEvent }) => {
              dimensions.value = nativeEvent.layout;
            }}
            sx={{ height: 'fit-content', width: 'fit-content' }}>
            {children}
          </View>
        </Animated.View>
      </View>
    </ModalContainer>
  );
};
